module.exports = __webpack_public_path__ + "static/media/py.f1fa6887.svg";